export default __webpack_public_path__ + "furnace.png?89b5b83f7f5bda6871c8ceab7afa308f";